import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/landing.css";
import logoLight from "../images/mockq-logo-light.png";
import logoDark from "../images/mockq-logo-dark.png";

export default function PublicNavbar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const goTo = (id) => (e) => {
    e.preventDefault();

    if (pathname === "/") {
      document
        .getElementById(id)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      // Landing reads location.state.scrollTo after it renders
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <header className="mq-theme mq-navbar">
      <div className="mq-wrap">
        <nav className="mq-nav" aria-label="Main navigation">
          <Link to="/" className="mq-nav-brand" aria-label="MockQ home">
            <img className="lg-l" alt="MockQ" src={logoLight} />
            <img className="lg-d" alt="" src={logoDark} />
          </Link>

          <div className="mq-nav-links">
            <a href="/#compare" onClick={goTo("compare")}>
              Compare
            </a>
            <a href="/#contact" onClick={goTo("contact")}>
              Contact
            </a>
          </div>
        </nav>
      </div>
    </header>
  );
}